<template>
  <div v-if="errors && errors.length > 0" class="validation-table">
    <v-data-table
      :headers="headers"
      :items="errors"
      :loading="loading"
      :items-per-page="5"
      class="elevation-1"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.rowNumber }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.identificationNumber }}</td>
          <td class="error-text">{{ item.error }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
  <div v-else-if="!loading" class="no-errors">
    <v-alert type="success" outlined>
      {{ $t('massive.validationTable.noErrors') }}
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'MassiveValidationTable',
  props: {
    errors: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        { text: this.$t('massive.validationTable.row'), value: 'rowNumber', align: 'center', class: 'primary--text font-weight-medium' },
        { text: this.$t('massive.validationTable.email'), value: 'email', align: 'left', class: 'primary--text font-weight-medium' },
        { text: this.$t('massive.validationTable.identification'), value: 'identificationNumber', align: 'left', class: 'primary--text font-weight-medium' },
        { text: this.$t('massive.validationTable.error'), value: 'error', align: 'left', class: 'primary--text font-weight-medium' }
      ]
    };
  }
};
</script>

<style lang="css" scoped>
.validation-table {
  margin-top: 16px;
}

.error-text {
  color: #ff5252;
  font-weight: 500;
  word-break: break-word;
  line-height: 1.4;
}

.no-errors {
  margin-top: 16px;
}
</style>
